(function () {
    'use strict';

    angular
        .module('app')
        .controller('requiredFields', requiredFields);

    requiredFields.$inject = ['loginService', 'requiredFieldsService', 'dataCardService', '$q', '$filter', '$timeout'];

    function requiredFields(loginService, requiredFieldsService, dataCardService, $q, $filter, $timeout) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'requiredFields';
        vm.loginService = loginService;
        vm.rfService = requiredFieldsService;
        vm.missingValues = true;
        vm.processing = false;
        vm.allowFreeText = false;

        vm.nonEditableReasons = {
            0: "Unknown",
            1: loginService.resourceStrings["RF_NOEDITRIGHTS"],
            2: loginService.resourceStrings["RF_NOPROTECTEDRIGHTS"],
            3: loginService.resourceStrings["RF_NOEDITABLEFIELD"],
            4: loginService.resourceStrings["RF_NOUPDATEDOCRIGHTS"],
            5: loginService.resourceStrings["RF_NOTCREATOR"]
        }

        vm.onControlButtonClicked = function (response) {
            //update
            if (response === "OK" && !vm.rfService.holdUpdate) {
                vm.processing = true;

                if (vm.rfService.commandCode == 101) {
                    vm.rfService.updateRecord().then(function () {
                        requiredFieldsService.closeDialog(response);
                    }, function (error) {
                        if (error.status == 409) {
                            vm.rfService.showErrorDialog("Record is already tagged by: " + error.data.Message);
                            //alert("Record is already tagged by:", error.data.Message);
                        }
                        else {
                            vm.rfService.showErrorDialog(error.data.Message);
                            //alert("error:", error.data.Message);
                        }
                    });
                }
                else {
                    vm.rfService.addToQueue();
                    requiredFieldsService.closeDialog(response);
                }
            }
            else {
                requiredFieldsService.closeDialog(response);
            }           
        }

        //gets restricted fields data for the selection box
        vm.getRestricted = function (schemaId) {
            var deferred = $q.defer();
            var options = [];
            dataCardService.getRestrictedValues(schemaId).then(function (items) {
                angular.forEach(items, function (item, key) {
                    if (item.name != "") {
                        options.push(item.name);
                    }

                });

                var emptyValue = false;
                for (var item in items) {
                    if (items[item].name === "") {
                        emptyValue = true;
                    }
                }

                vm.allowFreeText = emptyValue; 

                deferred.resolve(options);
            });
            return deferred.promise;
        };

        vm.restrictedFieldChanged = function (value, id) {
            if (value == "++++##filtering##++++") {
                vm.missingValues = true;
                return;
            }
            else {
                checkMissingValues();
            }       
        }

        vm.datePicked = function (id, value) {
            updateValue(id, value);
            checkMissingValues();
        }

        vm.valueChanged = function () {
            checkMissingValues();
        }

        function updateValue(schemaId, value) {
            angular.forEach(vm.rfService.currentLibSettings.Fields, function (item) {
                if (item.fieldDef.schemaID == schemaId) {
                    item.UpdatedValue = value.onDateSearchValue;
                }
            });
        }

        function checkMissingValues() {
            $timeout(function () {
                vm.missingValues = false;
                angular.forEach(vm.rfService.currentLibSettings.Fields, function (item) {
                    if (item.Name == "C_DROPDOWN") {
                        //console.log(item);
                        //console.log("value", item.UpdatedValue);
                    }
                    if (!item.UpdatedValue || item.UpdatedValue.length === 0 || item.UpdatedValue === "") {
                        vm.missingValues = true;
                    }
                });
                //console.log("missing values", vm.missingValues);
            });
            
        }

        activate();

        function activate() { }
    }


})();
